import { useMemo } from 'react';

import {
  ProductCoverageCatalog,
  CoverageCatalog,
  CoverageCatalogResume,
} from 'data-layer-cr/dist/models';

// Constants
import COVERAGES_BENEFITS_LIST from 'src/constants/additionalCoverageBenefits';

type UseCoverageColectiveResumeResult = {
  coverages: CoverageCatalog[];
  coverageResumes: CoverageCatalogResume[];
  additionalBenefits: CoverageCatalog[];
};

type Props = {
  coveragesForProduct: ProductCoverageCatalog;
  productType: string;
};

export default function useCoverageColectiveResume({
  coveragesForProduct,
  productType,
}: Props): UseCoverageColectiveResumeResult {
  return useMemo(() => {
    const selectedProduct = Object.keys(coveragesForProduct).includes(
      productType,
    )
      ? coveragesForProduct[productType]
      : {
          coverages: [],
          coverageResumes: [],
        };

    const coverageList = selectedProduct.coverages.filter(
      (c) => !COVERAGES_BENEFITS_LIST.includes(c.code),
    );
    const aditionalBenefitsList = selectedProduct.coverages.filter((c) =>
      COVERAGES_BENEFITS_LIST.includes(c.code),
    );
    return {
      coverages: coverageList,
      additionalBenefits: aditionalBenefitsList,
      coverageResumes: selectedProduct.coverageResumes,
    };
  }, [coveragesForProduct, productType]);
}
